<i18n>
{
  "en": {
    "speed": "Speed",
    "margin": "Margin",
    "popularity": "Popularity",
    "stock": "Stock",
    "crossSelling": "Cross-Selling",
    "strategic": "Strategic"
  },
  "es": {
    "speed": "Velocidad",
    "margin": "Margen",
    "popularity": "Popularidad",
    "stock": "Stock",
    "crossSelling": "Cross-Selling",
    "strategic": "Stratégico"
  }
}
</i18n>
<template>
  <div class="wrapper">
    <v-card-subtitle class="title body-1 py-0 pl-8 pt-2" v-text="title"/>
    <radar-chart v-on="$listeners" class="chart"
       :chart-data="chartData" :options="chartOptions"
       :width="300" :height="300"/>
  </div>
</template>
<script>
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import RadarChart from '@ulibs/unfrontcharts/components/RadarChart';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
@Components({ RadarChart })
export default class ProductRadar extends Vue {
  @Prop({ type: Object, required: true }) kpis;

  @Prop({ type: String, required: true }) productName;

  @Prop({ type: Boolean, default: false }) isLoading;

  chartOptions = {
    elements: {
      line: {
        borderWidth: 3
      }
    },
    scale: {
      ticks: {
        display: false,
        beginAtZero: true,
        min: 0.0,
        max: 2.0,
        stepSize: 0.25,
      }
    },
    legend: {
      display: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      duration: 1000
    }
  };

  get title() {
    const maxTitleLength = 40;
    const truncate = (input) => (input.length > maxTitleLength ? `${input.substring(0, maxTitleLength)}...` : input);
    return truncate(this.productName);
  }

  get filledKpis() {
    return Object.fromEntries(Object.entries(this.kpis).filter(([key, value]) => value !== null));
  }

  get dataset() {
    return {
      data: Object.values(this.filledKpis),
      backgroundColor: this.$vuetify.theme.currentTheme.secondary,
      borderWidth: 1
    };
  }

  get labels() {
    return Object.keys(this.filledKpis).map((kpiName) => this.$t(kpiName));
  }

  get chartData() {
    return {
      labels: this.labels,
      datasets: [this.dataset]
    };
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  justify-items: center;
  grid-gap: 10px;
  grid-template-areas:
    'title'
    'chart';
}

.title {
  grid-area: title;
}

.chart {
  grid-area: chart;
}
</style>
